import { create } from 'zustand';

import { fetchInitialData } from '@/api/api';
import { useCoursesStore } from '@/stores/coursesStore';

interface AppState {
  isInitialized: boolean;
  isLoading: boolean;
  error: string | null;
  entitlements: string[];
  initializeApp: () => Promise<void>;
  addEntitlement: (courseId: string) => void;
  removeEntitlement: (courseId: string) => void;
}

export const useAppStore = create<AppState>((set, get) => ({
  isInitialized: false,
  isLoading: false,
  error: null,
  entitlements: [],

  initializeApp: async () => {
    if (get().isInitialized || get().isLoading) {
      return;
    }

    set({ isLoading: true, error: null });

    try {
      const data = await fetchInitialData();

      if (data) {
        // Update courses store with fetched courses
        useCoursesStore.getState().setCourses(data.courses);

        set({
          entitlements: data.entitlements,
          isInitialized: true,
          isLoading: false
        });
      }
    } catch (error) {
      const errorMessage = error instanceof Error ? error.message : 'Failed to initialize app';

      set({
        error: errorMessage,
        isLoading: false
      });

      // Also set error in courses store
      useCoursesStore.getState().setError(errorMessage);
    }
  },

  addEntitlement: (courseId: string) => {
    const current = get().entitlements;
    if (!current.includes(courseId)) {
      set({ entitlements: [...current, courseId] });
    }
  },

  removeEntitlement: (courseId: string) => {
    const current = get().entitlements;
    if (current.includes(courseId)) {
      set({ entitlements: current.filter(id => id !== courseId) });
    }
  },

}));